webpackJsonp([1],{

/***/ "1GFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = dfs;
/* harmony export (immutable) */ __webpack_exports__["a"] = bfs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);



var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dfs),
    _marked2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(bfs);

function dfs(network, v) {
  var marked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
  var exploredEdges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

  var i,
      edge,
      id,
      w,
      value,
      _value,
      _args = arguments;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dfs$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          console.log(_args);
          marked.add(v);

          i = 0;

        case 3:
          if (!(i < network.body.nodes[v].edges.length)) {
            _context.next = 23;
            break;
          }

          edge = network.body.nodes[v].edges[i];
          id = edge.id, w = edge.toId;

          if (marked.has(w)) {
            _context.next = 15;
            break;
          }

          marked.add(w);

          value = [id, 'search'];

          exploredEdges.add(id);
          _context.next = 12;
          return value;

        case 12:
          return _context.delegateYield(dfs(network, w, marked, exploredEdges), 't0', 13);

        case 13:
          _context.next = 20;
          break;

        case 15:
          if (exploredEdges.has(id)) {
            _context.next = 20;
            break;
          }

          _value = [id, 'return'];

          exploredEdges.add(id);
          _context.next = 20;
          return _value;

        case 20:
          i++;
          _context.next = 3;
          break;

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function bfs(network, v) {
  var Q, marked, exploredEdges, _v, i, edge, id, w, value, _value2;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function bfs$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          Q = [];
          marked = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
          exploredEdges = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();


          marked.add(v);
          Q.push(v);

        case 5:
          if (!Q.length) {
            _context2.next = 30;
            break;
          }

          _v = Q.shift();
          i = 0;

        case 8:
          if (!(i < network.body.nodes[_v].edges.length)) {
            _context2.next = 28;
            break;
          }

          edge = network.body.nodes[_v].edges[i];
          id = edge.id, w = edge.toId;

          if (marked.has(w)) {
            _context2.next = 20;
            break;
          }

          value = [id, 'search'];

          exploredEdges.add(id);
          _context2.next = 16;
          return value;

        case 16:

          Q.push(w);
          marked.add(w);
          _context2.next = 25;
          break;

        case 20:
          if (exploredEdges.has(id)) {
            _context2.next = 25;
            break;
          }

          _value2 = [id, 'return'];

          exploredEdges.add(id);
          _context2.next = 25;
          return _value2;

        case 25:
          i++;
          _context2.next = 8;
          break;

        case 28:
          _context2.next = 5;
          break;

        case 30:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "1jzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane"},[[(_vm.animation)?_c('header',{staticClass:"toolbar toolbar-header"},[_c('div',{staticClass:"toolbar-actions"},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.stopAnimation}},[_c('span',{staticClass:"icon icon-stop icon-text"}),_vm._v("\n            Finish\n          ")])])]):(_vm.selected)?_c('header',{staticClass:"toolbar toolbar-header"},[_c('div',{staticClass:"toolbar-actions"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.animateSearch('dfs')}}},[_c('span',{staticClass:"icon icon-search icon-text"}),_vm._v("\n            Depth First Search\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.animateSearch('bfs')}}},[_c('span',{staticClass:"icon icon-search icon-text"}),_vm._v("\n            Breadth First Search\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.animateSearch('prim')}}},[_c('span',{staticClass:"icon icon-search icon-text"}),_vm._v("\n            Prim\n          ")])])]):_c('header',{staticClass:"toolbar toolbar-header"},[_c('div',{staticClass:"toolbar-actions"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.animateSearch('kruskal')}}},[_c('span',{staticClass:"icon icon-search icon-text"}),_vm._v("\n            Kruskal\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.animateSearch('boruvka')}}},[_c('span',{staticClass:"icon icon-search icon-text"}),_vm._v("\n            Boruvka\n          ")]),_vm._v("\n\n          |\n\n          "),_c('span',[_vm._v("Click on some node for more algorithms")])])])],_vm._v(" "),_c('div',{ref:"network",staticClass:"network"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5qpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__ = __webpack_require__("WcWR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9394922_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__ = __webpack_require__("1jzA");
function injectStyle (ssrContext) {
  __webpack_require__("oreX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9394922"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9394922_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FqUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

var id = 0;

/* harmony default export */ __webpack_exports__["a"] = ([{
  id: id++,
  name: 'First',
  description: '10/17/2017',

  options: {
    layout: {
      randomSeed: 2,
      hierarchical: false
    }
  },

  nodes: [{ id: 1, label: '1' }, { id: 2, label: '2' }, { id: 3, label: '3' }, { id: 4, label: '4' }, { id: 5, label: '5' }, { id: 6, label: '6' }, { id: 7, label: '7' }],

  edges: [{ from: 1, to: 2 }, { from: 1, to: 3 }, { from: 2, to: 3 }, { from: 3, to: 4 }, { from: 3, to: 5 }, { from: 3, to: 6 }, { from: 3, to: 7 }, { from: 4, to: 5 }]
}, {
  id: id++,
  name: 'Second',
  description: '10/31/2017',

  options: {
    layout: {
      randomSeed: 2,
      hierarchical: false
    }
  },

  nodes: [{ id: 'A', label: 'A' }, { id: 'B', label: 'B' }, { id: 'C', label: 'C' }, { id: 'D', label: 'D' }, { id: 'E', label: 'E' }, { id: 'F', label: 'F' }],

  edges: [{ from: 'A', to: 'B' }, { from: 'A', to: 'C' }, { from: 'B', to: 'C' }, { from: 'B', to: 'D' }, { from: 'B', to: 'F' }, { from: 'C', to: 'D' }, { from: 'C', to: 'E' }, { from: 'D', to: 'E' }, { from: 'D', to: 'F' }, { from: 'E', to: 'F' }]
}, {
  id: id++,
  name: 'Extra',

  options: {
    layout: {
      randomSeed: 2,
      hierarchical: {
        direction: 'UD',
        sortMethod: 'directed'
      }
    }
  },

  nodes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(12), function (_, i) {
    return { id: i + 1, label: '' + (i + 1) };
  }),

  edges: [{ from: 1, to: 2 }, { from: 1, to: 3 }, { from: 1, to: 4 }, { from: 2, to: 5 }, { from: 2, to: 6 }, { from: 4, to: 7 }, { from: 4, to: 8 }, { from: 5, to: 9 }, { from: 5, to: 10 }, { from: 7, to: 11 }, { from: 7, to: 12 }]
}, {
  id: id++,
  name: 'Weighted Undirected',
  description: '11/07/2017',

  options: {
    layout: {
      randomSeed: 2,
      hierarchical: false
    }
  },

  nodes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(6), function (_, i) {
    return { id: i + 1, label: '' + (i + 1) };
  }),

  edges: [{ from: 1, to: 2, label: '1' }, { from: 1, to: 3, label: '3' }, { from: 2, to: 3, label: '1' }, { from: 2, to: 4, label: '1' }, { from: 3, to: 5, label: '2' }, { from: 2, to: 5, label: '4' }, { from: 3, to: 4, label: '3' }, { from: 4, to: 5, label: '2' }, { from: 4, to: 6, label: '1' }, { from: 5, to: 6, label: '2' }]
}]);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b174b12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qanG");
function injectStyle (ssrContext) {
  __webpack_require__("xX/k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b174b12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = animatedDfs;
/* harmony export (immutable) */ __webpack_exports__["d"] = animatedBfs;
/* harmony export (immutable) */ __webpack_exports__["c"] = animatePrim;
/* harmony export (immutable) */ __webpack_exports__["b"] = animateKruskal;
/* harmony export (immutable) */ __webpack_exports__["a"] = animateBoruvka;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__("1GFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__minimum_spanning_tree__ = __webpack_require__("ssJI");




var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(animatedDfs),
    _marked2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(animatedBfs),
    _marked3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(animatePrim),
    _marked4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(animateKruskal),
    _marked5 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(animateBoruvka);




function animatedDfs(network, nodes, edges, start) {
  var n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, _ref2, edgeId, path, edge, from, to, toFocus;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function animatedDfs$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          n = 1;
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 4;
          _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(Object(__WEBPACK_IMPORTED_MODULE_3__search__["b" /* dfs */])(network, start));

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 23;
            break;
          }

          _ref = _step.value;
          _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
          edgeId = _ref2[0];
          path = _ref2[1];
          edge = edges.get(edgeId);
          from = edge.from, to = edge.to;


          edges.update({ id: edgeId, label: '(' + n++ + ') ' + path });

          nodes.update({ id: from, color: 'red' });
          nodes.update({ id: to, color: 'blue' });

          toFocus = path === 'return' ? from : to;

          network.view.focus(toFocus, {
            scale: 1.5,
            animation: {
              duration: 500, easingFunction: 'easeInOutQuad'
            }
          });

          _context.next = 20;
          return;

        case 20:
          _iteratorNormalCompletion = true;
          _context.next = 6;
          break;

        case 23:
          _context.next = 29;
          break;

        case 25:
          _context.prev = 25;
          _context.t0 = _context['catch'](4);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 29:
          _context.prev = 29;
          _context.prev = 30;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 32:
          _context.prev = 32;

          if (!_didIteratorError) {
            _context.next = 35;
            break;
          }

          throw _iteratorError;

        case 35:
          return _context.finish(32);

        case 36:
          return _context.finish(29);

        case 37:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 25, 29, 37], [30,, 32, 36]]);
}

function animatedBfs(network, nodes, edges, start) {
  var n, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref3, _ref4, edgeId, path, edge, from, to, toFocus;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function animatedBfs$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          n = 1;
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context2.prev = 4;
          _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(Object(__WEBPACK_IMPORTED_MODULE_3__search__["a" /* bfs */])(network, start));

        case 6:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context2.next = 23;
            break;
          }

          _ref3 = _step2.value;
          _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
          edgeId = _ref4[0];
          path = _ref4[1];
          edge = edges.get(edgeId);
          from = edge.from, to = edge.to;


          edges.update({ id: edgeId, label: '(' + n++ + ') ' + path });

          nodes.update({ id: from, color: 'red' });
          nodes.update({ id: to, color: 'blue' });

          toFocus = path === 'return' ? from : to;

          network.view.focus(toFocus, {
            scale: 1.5,
            animation: {
              duration: 500, easingFunction: 'easeInOutQuad'
            }
          });

          _context2.next = 20;
          return;

        case 20:
          _iteratorNormalCompletion2 = true;
          _context2.next = 6;
          break;

        case 23:
          _context2.next = 29;
          break;

        case 25:
          _context2.prev = 25;
          _context2.t0 = _context2['catch'](4);
          _didIteratorError2 = true;
          _iteratorError2 = _context2.t0;

        case 29:
          _context2.prev = 29;
          _context2.prev = 30;

          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }

        case 32:
          _context2.prev = 32;

          if (!_didIteratorError2) {
            _context2.next = 35;
            break;
          }

          throw _iteratorError2;

        case 35:
          return _context2.finish(32);

        case 36:
          return _context2.finish(29);

        case 37:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[4, 25, 29, 37], [30,, 32, 36]]);
}

function animatePrim(network, nodes, edges, start) {
  var backupEdges, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, edge;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function animatePrim$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          backupEdges = edges.get().slice();

          edges.remove(edges.map(function (_ref5) {
            var id = _ref5.id;
            return id;
          }));

          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context3.prev = 5;
          _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(Object(__WEBPACK_IMPORTED_MODULE_4__minimum_spanning_tree__["c" /* prim */])(network, nodes, backupEdges, start));

        case 7:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context3.next = 15;
            break;
          }

          edge = _step3.value;

          edges.add(edge);
          _context3.next = 12;
          return;

        case 12:
          _iteratorNormalCompletion3 = true;
          _context3.next = 7;
          break;

        case 15:
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3['catch'](5);
          _didIteratorError3 = true;
          _iteratorError3 = _context3.t0;

        case 21:
          _context3.prev = 21;
          _context3.prev = 22;

          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }

        case 24:
          _context3.prev = 24;

          if (!_didIteratorError3) {
            _context3.next = 27;
            break;
          }

          throw _iteratorError3;

        case 27:
          return _context3.finish(24);

        case 28:
          return _context3.finish(21);

        case 29:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[5, 17, 21, 29], [22,, 24, 28]]);
}

function animateKruskal(network, nodes, edges) {
  var backupEdges, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, edge;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function animateKruskal$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          backupEdges = edges.get().slice();

          edges.remove(edges.map(function (_ref6) {
            var id = _ref6.id;
            return id;
          }));

          _iteratorNormalCompletion4 = true;
          _didIteratorError4 = false;
          _iteratorError4 = undefined;
          _context4.prev = 5;
          _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(Object(__WEBPACK_IMPORTED_MODULE_4__minimum_spanning_tree__["b" /* kruskal */])(network, nodes, backupEdges));

        case 7:
          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
            _context4.next = 15;
            break;
          }

          edge = _step4.value;

          edges.add(edge);
          _context4.next = 12;
          return;

        case 12:
          _iteratorNormalCompletion4 = true;
          _context4.next = 7;
          break;

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t0 = _context4['catch'](5);
          _didIteratorError4 = true;
          _iteratorError4 = _context4.t0;

        case 21:
          _context4.prev = 21;
          _context4.prev = 22;

          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }

        case 24:
          _context4.prev = 24;

          if (!_didIteratorError4) {
            _context4.next = 27;
            break;
          }

          throw _iteratorError4;

        case 27:
          return _context4.finish(24);

        case 28:
          return _context4.finish(21);

        case 29:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[5, 17, 21, 29], [22,, 24, 28]]);
}

function animateBoruvka(network, nodes, edges) {
  var backupEdges, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, edge;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function animateBoruvka$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          backupEdges = edges.get();

          if (backupEdges.every(function (_ref7) {
            var label = _ref7.label;
            return +label;
          })) {
            _context5.next = 3;
            break;
          }

          return _context5.abrupt('return', alert('Cannot run Boruvka algorithm on a non-weighted graph'));

        case 3:

          edges.remove(edges.map(function (_ref8) {
            var id = _ref8.id;
            return id;
          }));

          _iteratorNormalCompletion5 = true;
          _didIteratorError5 = false;
          _iteratorError5 = undefined;
          _context5.prev = 7;
          _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(Object(__WEBPACK_IMPORTED_MODULE_4__minimum_spanning_tree__["a" /* boruvka */])(network, nodes, backupEdges));

        case 9:
          if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
            _context5.next = 17;
            break;
          }

          edge = _step5.value;

          edges.add(edge);
          _context5.next = 14;
          return;

        case 14:
          _iteratorNormalCompletion5 = true;
          _context5.next = 9;
          break;

        case 17:
          _context5.next = 23;
          break;

        case 19:
          _context5.prev = 19;
          _context5.t0 = _context5['catch'](7);
          _didIteratorError5 = true;
          _iteratorError5 = _context5.t0;

        case 23:
          _context5.prev = 23;
          _context5.prev = 24;

          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }

        case 26:
          _context5.prev = 26;

          if (!_didIteratorError5) {
            _context5.next = 29;
            break;
          }

          throw _iteratorError5;

        case 29:
          return _context5.finish(26);

        case 30:
          return _context5.finish(23);

        case 31:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[7, 19, 23, 31], [24,, 26, 30]]);
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("olkN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "WcWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vis__ = __webpack_require__("/Foq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_animations__ = __webpack_require__("MOaC");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Vis doesn't work properly inside a Vue component state
var network = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Graph',
  data: function data() {
    return {
      nodes: false,
      edges: false,
      options: {},

      selected: false,
      animation: false,
      backup: { nodes: false, edges: false }
    };
  },
  mounted: function mounted() {
    this.mountNetwork();

    if (!this.currentGraph && this.graphs.length) {
      this.setCurrentGraphId(this.graphs[0].id);
    }
  },

  watch: {
    graph: function graph() {
      if (!this.graph) {
        return;
      }

      this.mountNetwork();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['currentGraph', 'graphs']), {
    graph: function graph() {
      return this.currentGraph;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])(['setCurrentGraphId']), {
    mountNetwork: function mountNetwork() {
      if (!this.graph) {
        return;
      }

      if (network) {
        network.destroy();
        network = false;
      }

      var container = this.$refs.network;
      this.nodes = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(this.graph.nodes);
      this.edges = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(this.graph.edges);
      var data = {
        nodes: this.nodes,
        edges: this.edges
      };
      var options = this.graph.options;
      network = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.Network(container, data, options);

      network.on('click', this.onClick);
      network.on('doubleClick', this.onDoubleClick);

      window.network = network;
    },
    onClick: function onClick(event) {
      this.selectNode(event.nodes[0]);
    },
    onDoubleClick: function onDoubleClick(event) {
      this.focusOnNode(event.nodes[0]);
    },
    selectNode: function selectNode(id) {
      this.selected = id;
    },
    focusOnNode: function focusOnNode(id) {
      network.view.focus(id, {
        scale: 1.5,
        animation: {
          duration: 500, easingFunction: 'easeInOutQuad'
        }
      });
    },
    time: function time(n) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, n);
      });
    },


    animateSearch: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(algorithm) {
        var animate, start, it, done, next;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.backup.nodes = this.graph.nodes;
                this.backup.edges = this.graph.edges;
                this.animation = true;

                animate = {
                  dfs: __WEBPACK_IMPORTED_MODULE_6__lib_animations__["e" /* animatedDfs */],
                  bfs: __WEBPACK_IMPORTED_MODULE_6__lib_animations__["d" /* animatedBfs */],
                  prim: __WEBPACK_IMPORTED_MODULE_6__lib_animations__["c" /* animatePrim */],
                  kruskal: __WEBPACK_IMPORTED_MODULE_6__lib_animations__["b" /* animateKruskal */],
                  boruvka: __WEBPACK_IMPORTED_MODULE_6__lib_animations__["a" /* animateBoruvka */]
                }[algorithm];
                start = this.selected;

                this.focusOnNode(start);
                it = animate(network, this.nodes, this.edges, start);
                done = false;
                _context.next = 10;
                return this.time(1000);

              case 10:
                if (!(this.animation && !done)) {
                  _context.next = 17;
                  break;
                }

                next = it.next();

                done = next.done;
                _context.next = 15;
                return this.time(1000);

              case 15:
                _context.next = 10;
                break;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function animateSearch(_x) {
        return _ref.apply(this, arguments);
      }

      return animateSearch;
    }(),

    stopAnimation: function stopAnimation() {
      this.animation = false;
      this.graph.nodes = this.backup.nodes;
      this.graph.edges = this.backup.edges;
      this.mountNetwork();
    }
  })
});

/***/ }),

/***/ "Xq4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pane pane-sm sidebar"},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.graphs),function(graph){return _c('li',{staticClass:"list-group-item clickable",class:{active: graph.id === _vm.currentGraphId}},[_c('div',{staticClass:"media-body",on:{"click":function($event){$event.preventDefault();_vm.setCurrentGraphId(graph.id)}}},[_c('strong',[_vm._v(_vm._s(graph.name))]),_vm._v(" "),(graph.description)?_c('p',[_vm._v(_vm._s(graph.description))]):_vm._e()])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Base__ = __webpack_require__("csSs");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Base',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Base__["a" /* default */]
  }]
}));

/***/ }),

/***/ "csSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__ = __webpack_require__("t2k+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f33540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__ = __webpack_require__("ds5o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f33540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Base_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ds5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"window-content"},[_c('sidebar'),_vm._v(" "),_c('graph')],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"toolbar toolbar-header"},[_c('h1',{staticClass:"title"},[_vm._v("UFPA Graphs 2017")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"toolbar toolbar-footer"},[_c('h1',{staticClass:"title"},[_c('a',{attrs:{"href":"https://github.com/lubien","target":"_blank"}},[_vm._v("João Ferreira")]),_vm._v(" |\n      "),_c('a',{attrs:{"href":"https://github.com/pablocabral","target":"_blank"}},[_vm._v("Pablo Cabral")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(['currentGraphId']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['graphs'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['setCurrentGraphId']))
});

/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b87703d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("Xq4y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b87703d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphs__ = __webpack_require__("FqUE");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  currentGraphId: false,
  graphs: __WEBPACK_IMPORTED_MODULE_2__graphs__["a" /* default */]
};

var mutations = {
  setCurrentGraphId: function setCurrentGraphId(state, id) {
    state.currentGraphId = id;
  }
};

window.state = state;

var actions = {};

var getters = {
  graphs: function graphs(_ref) {
    var graphs = _ref.graphs;

    return graphs;
  },
  currentGraph: function currentGraph(_ref2) {
    var graphs = _ref2.graphs,
        currentGraphId = _ref2.currentGraphId;

    return graphs[currentGraphId];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({ state: state, mutations: mutations, actions: actions, getters: getters }));

/***/ }),

/***/ "oreX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qanG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ssJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = prim;
/* harmony export (immutable) */ __webpack_exports__["b"] = kruskal;
/* harmony export (immutable) */ __webpack_exports__["a"] = boruvka;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vis__ = __webpack_require__("/Foq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search__ = __webpack_require__("1GFi");






var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(prim),
    _marked2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(kruskal),
    _marked3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(boruvka);




function xor(p, q) {
  return p && !q;
}

function sameSet(A, B) {
  return contains(A, B) && contains(B, A);
}

function contains(A, B) {
  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(B.values()).every(function (v) {
    return A.has(v);
  });
}

function hasCycle(network) {
  var anyEdgeId = network.body.edgeIndices[0];
  var from = network.body.edges[anyEdgeId].from;

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(Object(__WEBPACK_IMPORTED_MODULE_6__search__["b" /* dfs */])(network, from.id)).some(function (_ref, i, ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
        edgeId = _ref2[0];

    return ref.slice(i + 1).find(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 1),
          otherId = _ref4[0];

      return edgeId === otherId;
    });
  });
}

function prim(network, nodes, edges, v) {
  var edgeSet, N, T, V, _edgeSet$get$reduce, from, to, label, k;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function prim$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          edgeSet = new __WEBPACK_IMPORTED_MODULE_5_vis__["DataSet"](edges);
          N = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(nodes.map(function (_ref5) {
            var id = _ref5.id;
            return id;
          }));
          T = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a([v]);
          V = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(nodes.map(function (_ref6) {
            var id = _ref6.id;
            return id;
          }).filter(function (id) {
            return id !== v;
          }));

        case 4:
          if (sameSet(N, T)) {
            _context.next = 13;
            break;
          }

          _edgeSet$get$reduce = edgeSet.get({
            filter: function filter(_ref7) {
              var from = _ref7.from,
                  to = _ref7.to;

              return T.has(from) && V.has(to) || V.has(from) && T.has(to);
            }
          }).reduce(function (a, b) {
            return +a.label < +b.label ? a : b;
          }), from = _edgeSet$get$reduce.from, to = _edgeSet$get$reduce.to, label = _edgeSet$get$reduce.label;
          k = V.has(from) ? from : to;

          T.add(k);
          V.delete(k);

          _context.next = 11;
          return { from: from, to: to, label: label };

        case 11:
          _context.next = 4;
          break;

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function kruskal(network, nodes, edges) {
  var H, T;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function kruskal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          H = edges.sort(function (a, b) {
            return +a.label - +b.label;
          });
          T = H.shift();

        case 2:
          if (!H.length) {
            _context2.next = 10;
            break;
          }

          _context2.next = 5;
          return T;

        case 5:
          if (!hasCycle(network)) {
            _context2.next = 7;
            break;
          }

          return _context2.abrupt('return', alert('Graph has cycle'));

        case 7:
          T = H.shift();
          _context2.next = 2;
          break;

        case 10:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function connectedEdges(edgeA, edgeB) {
  return edgeA.from === edgeB.from || edgeA.from === edgeB.to || edgeA.to === edgeB.from || edgeA.to === edgeB.to;
}

function conectedComponents(others, component) {
  return others.filter(function (edges) {
    return edges.some(function (otherEdge) {
      return component.some(function (edge) {
        return connectedEdges(edge, otherEdge);
      });
    });
  });
}

function minimalConnectedComponent(others, component) {
  var min = void 0;
  var pairedComponent = void 0;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(others), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var edges = _step.value;

      var _connectedEdges = edges.filter();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/*
export function * boruvka (network, nodes, edges) {
  const components = edges.map(edge => [edge])

  while (components.length > 1) {
	for (let [i, component] of components.entries()) {
	  const others = components.filter((_, j) => i !== j)
	  const connected = conectedComponents(others, component)
	}
  }
}
*/

function connects(edge, a, b) {
  return edge.from === a && edge.to === b || edge.from === b && edge.to === a;
}

function connectedTo(edges, node) {
  return edges.filter(function (_ref8) {
    var to = _ref8.to,
        from = _ref8.from;
    return from === node.id || to === node.id;
  });
}

function boruvka(network, nodes, edges) {
  var _this = this;

  var components, edgesToAdd, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, component;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function boruvka$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          components = nodes.map(function (edge) {
            return [edge];
          });

        case 1:
          if (!(components.length > 1)) {
            _context4.next = 31;
            break;
          }

          edgesToAdd = [];
          _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(component) {
            var edgeId, edgeLabel, _loop2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, node, edge;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    edgeId = false;
                    edgeLabel = +Infinity;

                    _loop2 = function _loop2(node) {
                      var _iteratorNormalCompletion4 = true;
                      var _didIteratorError4 = false;
                      var _iteratorError4 = undefined;

                      try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(connectedTo(edges, node).filter(function (_ref10) {
                          var from = _ref10.from,
                              to = _ref10.to,
                              label = _ref10.label;
                          return +label > 0 && !component.some(function (_ref11) {
                            var id = _ref11.id;
                            return id === (node.id === from ? to : from);
                          });
                        })), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                          var _edge = _step4.value;

                          if (edgeLabel > +_edge.label) {
                            edgeLabel = +_edge.label;
                            edgeId = _edge.id;
                          }
                        }
                      } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                          }
                        } finally {
                          if (_didIteratorError4) {
                            throw _iteratorError4;
                          }
                        }
                      }
                    };

                    _iteratorNormalCompletion3 = true;
                    _didIteratorError3 = false;
                    _iteratorError3 = undefined;
                    _context3.prev = 6;


                    for (_iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(component); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      node = _step3.value;

                      _loop2(node);
                    }

                    _context3.next = 14;
                    break;

                  case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](6);
                    _didIteratorError3 = true;
                    _iteratorError3 = _context3.t0;

                  case 14:
                    _context3.prev = 14;
                    _context3.prev = 15;

                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }

                  case 17:
                    _context3.prev = 17;

                    if (!_didIteratorError3) {
                      _context3.next = 20;
                      break;
                    }

                    throw _iteratorError3;

                  case 20:
                    return _context3.finish(17);

                  case 21:
                    return _context3.finish(14);

                  case 22:
                    if (edgesToAdd.includes(edgeId)) {
                      _context3.next = 27;
                      break;
                    }

                    edge = edges.find(function (_ref9) {
                      var id = _ref9.id;
                      return id === edgeId;
                    });

                    edgesToAdd.push(edgeId);
                    _context3.next = 27;
                    return edge;

                  case 27:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _loop, _this, [[6, 10, 14, 22], [15,, 17, 21]]);
          });
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context4.prev = 7;
          _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(components);

        case 9:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context4.next = 15;
            break;
          }

          component = _step2.value;
          return _context4.delegateYield(_loop(component), 't0', 12);

        case 12:
          _iteratorNormalCompletion2 = true;
          _context4.next = 9;
          break;

        case 15:
          _context4.next = 21;
          break;

        case 17:
          _context4.prev = 17;
          _context4.t1 = _context4['catch'](7);
          _didIteratorError2 = true;
          _iteratorError2 = _context4.t1;

        case 21:
          _context4.prev = 21;
          _context4.prev = 22;

          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }

        case 24:
          _context4.prev = 24;

          if (!_didIteratorError2) {
            _context4.next = 27;
            break;
          }

          throw _iteratorError2;

        case 27:
          return _context4.finish(24);

        case 28:
          return _context4.finish(21);

        case 29:
          _context4.next = 1;
          break;

        case 31:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked3, this, [[7, 17, 21, 29], [22,, 24, 28]]);
}

/***/ }),

/***/ "t2k+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_vue__ = __webpack_require__("lZ5c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Graph__ = __webpack_require__("5qpT");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  components: { Sidebar: __WEBPACK_IMPORTED_MODULE_2__Sidebar_vue__["a" /* default */], Graph: __WEBPACK_IMPORTED_MODULE_3__Graph__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['currentGraph'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([]))
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xX/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5ec42013d4ae18febc53.js